import {
  Box,
  Badge,
  Heading,
  HStack,
  VStack,
  Text,
  IconButton,
  Progress,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { shootLocalConfetti } from "../utils/helperFunctions";
import { formatEuro } from "../utils/helperFunctions";

export const SavingGoalBoxes = ({
  goal,
  saved,
  onRemove,
  showConfetti,
  markConfettiShown,
}: {
  goal: any;
  saved: number;
  onRemove: (id: string) => void;
  showConfetti: boolean;
  markConfettiShown: () => void;
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [hasShown, setHasShown] = useState(false);

  const percentage = Math.min((saved / goal.amount) * 100, 100);
  const goalReached = saved >= goal.amount;

  useEffect(() => {
    if (goalReached && showConfetti && !hasShown && canvasRef.current) {
      shootLocalConfetti(canvasRef.current);
      setHasShown(true);
      markConfettiShown(); // Inform parent
    }
  }, [goalReached, showConfetti]);

  return (
    <Box
      p={3}
      borderColor={"gray.300"}
      borderWidth="1px"
      borderRadius="md"
      position="relative"
      overflow="hidden"
      bg={goalReached ? "green.50" : "white"}
    >
      {goalReached && (
        <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
          }}
        />
      )}
      <HStack justify="space-between" mb={1}>
        <VStack align="start" spaceY={1} pb={2}>
          {goal.title && (
            <Heading size="lg" lineHeight="short">
              {goal.title}
            </Heading>
          )}
          <Badge color="white" bg={"black"} pt={1} size={"sm"}>
            {goal.category}
          </Badge>
        </VStack>
        <IconButton
          size="sm"
          position={"absolute"}
          right={0}
          top={0}
          variant="ghost"
          aria-label="Ziel löschen"
          onClick={() => onRemove(goal.id)}
        >
          {/* @ts-ignore */}
          {<IoClose />}
        </IconButton>
      </HStack>

      <HStack justify="space-between" mb={2}>
        <Text fontSize="sm" color={goalReached ? "green.600" : "gray.600"}>
          {formatEuro(saved)} / {formatEuro(goal.amount)}
        </Text>
        <Badge
          bg={goalReached ? "green" : "orange"}
          color="white"
          fontSize="0.85rem"
          px={2}
          py={0.5}
          borderRadius="full"
        >
          {goalReached ? "Ziel Erreicht!" : "Sparphase"}
        </Badge>
      </HStack>

      <Progress.Root
        value={percentage}
        size="md"
        borderRadius="md"
        animated={true}
      >
        <Progress.Track>
          <Progress.Range
            style={{
              backgroundColor: goalReached ? "green" : "orange",
            }}
          />
        </Progress.Track>
      </Progress.Root>
    </Box>
  );
};
